export default __webpack_public_path__ + "static/media/Female.ba88ee83.svg";